import type { CastInlineContent, CastParagraph } from '../types';

/**
 * A paragraph with no text content — a blank line. Selection markers don't
 * count as content, so a caret sitting in a blank line leaves it empty.
 */
export function getIsEmptyCastParagraph(paragraph: CastParagraph): boolean {
  return !hasTextContent(paragraph.children);
}

function hasTextContent(children: CastInlineContent[]): boolean {
  return children.some(child => {
    if (child.type === 'text') return child.value !== '';
    if (child.type === 'link') return hasTextContent(child.children);
    return false;
  });
}
